import {
  expoDocsSvr
} from '../_services';
import {
  cloneDeep
} from "lodash";
const state = {
  tiposDocumentacion: [],

}

const actions = {
  /* funcion para listar todos los tipos de documentacion para el form tabla doc_types */
  acTodosTipos({
    commit
  }) {
    return new Promise((resolve, reject) => {
      expoDocsSvr.todosTipos().then(res => {
        commit("SET_TODOS_TIPOS", res.data);
        return resolve(res.data);
      })
    })
  },
  /* funcion para eliminar un documento */
  acEliminarDoc({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      expoDocsSvr.eliminarDoc(id).then(res => {
        return resolve(res.data);
      })
    }).catch(error => console.log)
  }

}

const mutations = {

  SET_TODOS_TIPOS(state, data) {
    state.tiposDocumentacion = data;
  }

}

const getters = {
  /* getter de los tipos registrados en la tabla doc_types  */
  gtrTodosTipos: (state) => cloneDeep(state.tiposDocumentacion),


}


export const expoDocs = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
